import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=7a8bfc84&"
import script from "./StatusList.vue?vue&type=script&lang=js&"
export * from "./StatusList.vue?vue&type=script&lang=js&"
import style0 from "./StatusList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports